import { __extends } from "tslib";
import { FederatedEvent } from './FederatedEvent';

var MutationEvent =
/** @class */
function (_super) {
  __extends(MutationEvent, _super);

  function MutationEvent(typeArg, relatedNode, prevValue, newValue, attrName, attrChange, prevParsedValue, newParsedValue) {
    var _this = _super.call(this, null) || this;

    _this.relatedNode = relatedNode;
    _this.prevValue = prevValue;
    _this.newValue = newValue;
    _this.attrName = attrName;
    _this.attrChange = attrChange;
    _this.prevParsedValue = prevParsedValue;
    _this.newParsedValue = newParsedValue;
    _this.type = typeArg;
    return _this;
  }

  MutationEvent.ADDITION = 2;
  MutationEvent.MODIFICATION = 1;
  MutationEvent.REMOVAL = 3;
  return MutationEvent;
}(FederatedEvent);

export { MutationEvent };